import React from "react";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import { HashLink } from "react-router-hash-link";

const useStyles = makeStyles({
  imgWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "60%",
    padding: "40px",
    paddingBottom: "30px",
    paddingTop: "30px",

    // "&:hover": { borderBottom: "5px solid #153a5b", paddingBottom: "25px" },
    "&:hover $animation": {
      transform: "scale(1.1)",
    },
  },
  title: {
    fontSize: "16px",
    paddingTop: "20px",
    paddingBottom: "10px",
    fontWeight: "bold",
    width: "80%",
  },
  subtitle: {
    fontSize: "12px",
    lineHeight: "180%",
    width: "80%",
    color: "#565553",
  },
  animation: {
    transition: "all 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
});

const AllProductEach = ({ title, subtitle, price, img, linkTo, productId }) => {
  const classes = useStyles();
  let url = "/product/" + linkTo + "#top";
  return (
    <HashLink smooth to={url}>
      <Box className={classes.item}>
        <Box sx={{ backgroundColor: "#f8f7f5" }} className={classes.imgWrapper}>
          <img
            width="200"
            height="190"
            alt={img}
            src={process.env.PUBLIC_URL + img}
            className={classes.animation}
          />
        </Box>
        <Box className={classes.title}>{title}</Box>
        <Box className={classes.subtitle}>{subtitle}</Box>
      </Box>
    </HashLink>
  );
};

export default AllProductEach;
